<template>
    <v-col cols="12" sm="12" md="12">
        <v-card class="elevation-4">
            <v-card-title>
                <v-toolbar flat>
                    <v-btn small dark color="primary" @click="dialog = true">
                        <v-icon left>fas fa-plus-square</v-icon>Nuevo departamento
                    </v-btn>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-col cols="12" md="8" sm="12" class="d-flex justify-end">
                    <v-text-field v-model="search" append-icon="fas fa-search" label="Buscar departamento" single-inline hide-details @keydown.enter="searchDepartamento">
                    </v-text-field>
                    <v-btn icon class="mt-4 ml-2" @click="reload()" title="Actualizar">
                        <v-icon dense>fas fa-sync</v-icon>
                    </v-btn>
                </v-col>
                <Columns :headers.sync="headers"></Columns>
            </v-card-title>
            <v-card-text>
            <v-data-table dense :headers="filteredHeaders" :items="departamentos" class="elevation-1"
            :loading="loading" :options.sync="options"
            :server-items-length="totalElements" :items-per-page="itemsPerPage"
            :page.sync="page" @page-count="totalPages = $event"
            hide-default-footer>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text" small>
                                <v-icon>fas fa-ellipsis-v</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item @click.prevent="show(item)" v-if="!item.eliminado">
                                <v-list-item-title>
                                    <v-icon small>fas fa-edit</v-icon> Editar departamento
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click.prevent="removeDepartamento(item)" v-if="!item.eliminado">
                                <v-list-item-title class="red--text">
                                    <v-icon small class="red--text">fas fa-trash-alt</v-icon> Borrar departamento
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
                <template v-slot:[`item.eliminado`]="{ item }">
                    <v-chip small :color="colorstatus(item.eliminado)" label x-small dark
                    v-text="!item.eliminado ? 'Activo' : 'Inactivo'">
                    </v-chip>
                </template>
            </v-data-table>
            </v-card-text>
            <v-card-actions>
                <PaginationNumber :itemsPerPage.sync="itemsPerPage" :pageCount.sync="totalPages"
                :totalElements.sync="totalElements" :page.sync="page" :initialize.sync="initialize" />
            </v-card-actions>
        </v-card>
        <NuevoDepartamento :dialog.sync="dialog" :initialize.sync="initTableDepartment"
        :handleModal="handleModal" v-if="dialog"/>

        <EditarDepartamento :dialog.sync="editDialog" :department.sync="getInfo" :initialize.sync="initTableDepartment"
        :handleModal="handleEditModal" v-if="editDialog"/>
    </v-col>
</template>
<script>
import DepartamentoDataService from '@/service/catalogo/departamento/departamentoDataService';
import NuevoDepartamento from './Nuevo.vue';
import EditarDepartamento from './Editar.vue';
import { pagedTableMixin } from '@/mixins/serverTableMixin';
import Columns from '@/components/shared/Columns.vue';
import PaginationNumber from '@/components/shared/PaginationNumber.vue';
import { extractMessage } from '@/helpers/errorHelper';
export default {
    name: 'ListaDepartamento',
    components : { NuevoDepartamento, EditarDepartamento, Columns, PaginationNumber },
    mixins: [pagedTableMixin],
    created(){
        this.fetchTableData();
    },
    data(){
        return {
            headers: [
                { text: 'Acciones', value: 'actions', sortable: false, groupable: false, show: true},
                { text: 'ID', align :' d-none', sortable: false, value: 'id' , visible: false, groupable: false, show: false},
                // { text: 'Clave', value: 'clave', sortable: false, groupable: false, show: true },
                { text: 'Departamento', value: 'departamento', sortable: false, groupable: false, show: true },
                { text: 'Estatus', value: 'eliminado', sortable: false, groupable: false, show: true },
            ],
            departamentos: [],
            dialog: false,
            editDialog: false,
            getInfo: []
        }
    },
    methods: {
        searchDepartamento(){
            this.doSearch();
        },
        fetchTable(params){
            return DepartamentoDataService.table( params );
        },
        applyRows({ rows, total, totalPages }){
            this.departamentos = rows;
            this.totalElements = total;
            this.totalPages = totalPages;
        },
        // Callback que reciben los diálogos de alta y edición.
        initTableDepartment(){
            this.reload();
        },
        show( item ){
            this.getInfo = item;
            this.editDialog = true;
        },
        removeDepartamento( item ){
            this.$swal.fire({
                title: '¿Estas seguro?',
                text: "¡No podrás revertir esto!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, eliminarlo!'
            }).then((result) => {
                if (result.value) {
                    DepartamentoDataService.delete( item.id ).then( resp => {
                        if( resp.status == 200 ){
                            this.$swal.fire({ icon: 'success', text: 'Departamento eliminado', title: 'Eliminando departamento', showConfirmButton: false, timer: 1500 });
                            this.initTableDepartment();
                        }
                    }).catch( err => {
                        this.$swal.fire({ icon: 'error', text: extractMessage(err), title: 'Error al eliminar el departamento', showConfirmButton: false, timer: 1500 });
                    });
                }
            }).catch( () => {
                this.$swal.fire({ icon: 'error', text: 'Proceso, cancelado', title: 'Error al eliminar el departamento', showConfirmButton: false, timer: 1500 });
            });
        },
        colorstatus( status ){ return status ? 'red' : 'green'; },
        handleModal(){ this.dialog = !this.dialog; },
        handleEditModal(){ this.editDialog = !this.editDialog; }
    },

    computed: {
        filteredHeaders() { return this.headers.filter( header => header.show ); }
    }
}
</script>